import classNames from 'classnames';
import $ from 'jquery';
import {map} from 'lodash';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import {
  getJobStates,
  SUCCESS_JOBS_STATES,
} from '../../../../../actions/entities/jobs';
import './JobsStates.css';

const initialState = {
  response: null,
};
class JobsStates extends React.Component {
  state = initialState;

  open = () => {
    this.props.dispatch(getJobStates()).then(res => {
      if (res && res.type === SUCCESS_JOBS_STATES) {
        this.setState({response: res.response});
      }
    });
  };

  onSubmit = () => $('#jobsStates').modal('hide');

  renderJobs = () => {
    const {response} = this.state;
    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Args</th>
            <th>Start</th>
            <th>End</th>
            <th className="exitCode">Exit code</th>
          </tr>
        </thead>
        <tbody>
          {map(
            response.jobs,
            ({name, args, running, startDate, endDate, exitCode}, id) => (
              <tr key={id} id={id} className={running ? 'running' : ''}>
                <td>{name}</td>
                <td>{args}</td>
                <td>
                  {startDate && moment(startDate).format('DD/MM HH:mm:ss')}
                </td>
                <td>{endDate && moment(endDate).format('DD/MM HH:mm:ss')}</td>
                <td
                  className={classNames(
                    'exitCode',
                    exitCode ? 'red' : 'green',
                  )}>
                  {exitCode}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    );
  };

  render() {
    const {response} = this.state;
    return (
      response && (
        <div id="jobs-states">
          {this.renderJobs()}
          <div className="runningCaptionContainer">
            <div className="runningCaption" /> Running
          </div>
          <div class="modal-footer">
            <button
              onClick={this.onSubmit}
              type="button"
              class="btn btn-success">
              Ok
            </button>
          </div>
        </div>
      )
    );
  }
}

export default connect(null, dispatch => ({dispatch}), null, {
  forwardRef: true,
})(JobsStates);



// WEBPACK FOOTER //
// ./src/pages/OnSite/FullPlayers/Widgets/JobsStates/index.js